import React from 'react';
import { ImportSource } from '../../graphql/generated/graphql';
import Link from '../../utils/router/Link';
import ImportFileModal from './ImportFileModal';

interface ConfluenceImportModalProps {
  close: () => void;
}

const ConfluenceImportModal = ({ close }: ConfluenceImportModalProps) => (
  <ImportFileModal
    close={close}
    source={ImportSource.Confluence}
    uploaderInfo="Upload Confluence backup zip file"
    footer={
      <>
        Upload your{' '}
        <Link to="https://go.slab.com/importing-from-confluence" newTab>
          Confluence backup file
        </Link>{' '}
        to import into Slab.
      </>
    }
    forceBucketUpload
  />
);

export default ConfluenceImportModal;
